import { ref } from 'vue'
import { FlowState } from '../constants/flowState'

export const useFlowState = () => {
  const flow = ref<FlowState>(FlowState.Idle)

  return {
    flow,
    FlowState
  }
}
